import { Column } from 'primereact/column';
import { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { MonitoreoService } from '../../service/monitoreo/MonitoreoService';
import { Dropdown } from 'primereact/dropdown';

export const ConfEmpresa = ({ archivo, toast, permss, generic, opcion }) => {

    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [registers, setRegisters] = useState(null);
    const conSrv = new MonitoreoService();
    const [lazyParams, setLazyParams] = useState(generic.paramLazy({ razon_social: 'contains', identificacion: 'contains' }, null));

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const onPage = (event) => {
        event.filters = lazyParams.filters;
        setLazyParams(event);
    }

    const onSort = (event) => {
        event.filters = lazyParams.filters;
        setLazyParams(event);
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    const loadLazyData = () => {
        setLoading(true);

        let _lazyParams = lazyParams;
        _lazyParams.idc = archivo?.id;
        setLoading(true);
        conSrv.listado("ficha/config-archivo/lista-empresa", { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegisters(res.data.registros);
            setLoading(false);
        }).finally(() => {
            setLoading(false);
        });
    }

    const onChange = (e, rowData) => {
        if (rowData.obligatorio === e.value?.cat_id) return;

        const data = {
            id: rowData.id,
            con: archivo?.id,
            obligatorio: e.value?.cat_id,
            tipo: opcion
        };
        setLoading(true);
        conSrv.editar(data, 'ficha/config-archivo/catalogo-asignar').then(res => {
            generic.funcSuccess(res, toast);
            const regs = registers.map(info => {
                if (info.id === rowData.id) {
                    const data = { ...info, etiqueta: e.value?.nombre, obligatorio: e.value?.cat_id };
                    return data;
                }
                return info;
            });
            setRegisters(regs);
        }).catch(error => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
        }).finally(() => {
            setLoading(false);
        });
    }

    const obligatorioEditor = (options) => {
        const value = { cat_id: options.rowData?.obligatorio, nombre: options.rowData?.etiqueta };
        return (
            <Dropdown
                value={value}
                options={generic.sinonull}
                optionLabel="nombre"
                onChange={(e) => onChange(e, options.rowData)}
                placeholder="Seleccione"
                style={{ width: '100%' }}
                filter
                filterBy="nombre"
            />
        );
    };

    return (
        <DataTable value={registers} lazy className="datatable-responsive" filterDisplay="row" dataKey="id" paginator first={lazyParams.first} rows={10} totalRecords={totalRecords}
            onPage={onPage} onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder} onFilter={onFilter} filters={lazyParams.filters} loading={loading}
            editMode="cell">
            <Column field="razon_social" header='Razón social' sortable showFilterMenu={false} filterField='razon_social' filter filterPlaceholder='Filtrar' />
            <Column field="identificacion" header='Identificación' sortable showFilterMenu={false} filterField='identificacion' filter filterPlaceholder='Filtrar' />
            <Column field="etiqueta" header="Obligatorio" editor={(options) => obligatorioEditor(options)} style={{ width: '20%' }}></Column>
            <Column field="fecha" header="Fecha cambio" style={{ width: '15%' }}></Column>
        </DataTable>
    )
}
